module.exports = __webpack_public_path__ + "assets/img/footer_logo_7.1078e20e.png";